import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Container from "react-bootstrap/Container";
import RouteList from "./routes";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import ErrorBoundary from "./common/Error/ErrorBoundry";
import { Link, useNavigate } from "react-router-dom";
import Newtab from "./common/Error/NewTab";

import SplunkRum from '@splunk/otel-web';
   
     SplunkRum.init({
      beaconUrl: 'https://cdn.signalfx.com/o11y-gdi-rum/v0.19.1/splunk-otel-web.js',
      rumAuth: '_wr2OE9Y5k-VMISMa_J8hA',
      app: 'sbp-dev-portal',
      environment: 'dev', // e.g., production, staging
      debug : 'true',
    });  

function App() {
  return (
    <>
      <Router>
        <Container data-testid="container">
          <Provider store={store}>
            <Newtab />
            <ErrorBoundary>
              <RouteList />
            </ErrorBoundary>
          </Provider>
        </Container>
      </Router>
    </>
  );
}

export default App;
